var _style, _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoilerGreenIcon = function SvgBoilerGreenIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Imagery",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A9828;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 240,
    cy: 491,
    r: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 400,
    cy: 491,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319,362c0.2,0,0.5,0,0.7,0c0.1,0,0.2,0,0.3,0c0.3,0,0.5,0,0.8,0c72.3-0.8,83.7-47.8,78.4-82.5 c-5.9-39.1-56.1-90.9-56.1-90.9l-12.5,13.5L319,158c0,0-71.1,74.7-78.5,124.3C235.1,318,255.9,362,319,362L319,362z M336.8,336.4 c-6,4-13,5.4-16.1,5.6c-0.3,0-0.7,0-1,0c-2.9-0.1-10.1-1.5-16.4-5.6c-8-5.2-9-11.3-9-16c0-7.2,6-17.4,16.5-28c3.1-3.2,6.3-6,9.2-8.4 c2.9,2.4,6.1,5.2,9.2,8.4c10.5,10.6,16.5,20.8,16.5,28C345.8,325.1,344.7,331.1,336.8,336.4L336.8,336.4z M260.2,285.3 c2.5-16.7,16-42.1,38-71.4c3.8-5,7.5-9.8,11.1-14.2l2,7.6l9.3,35.1l22.2-23.9c14.8,18,33.8,44.7,36.7,64.1 c3.6,23.7-4.1,36.8-9.1,42.5c-1.7,2-3.7,3.8-5.9,5.5c0.8-3.1,1.2-6.4,1.2-10.1c0-31.7-45.8-61.5-45.8-61.5s-45.8,29.7-45.8,61.5 c0,2.9,0.3,5.6,0.8,8.2c-1.6-1.4-3.1-2.8-4.4-4.4C262,314.2,258.1,299.6,260.2,285.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.9,60.1h-360c-22.1,0-40,17.9-40,40v439.8c0,22.2,18,40.2,40.2,40.2h330.5l-10.7-40l40-10.7L519.9,60.1 L519.9,60.1z M479.9,540.1H160.1c0,0-0.1,0-0.1,0l0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0-0.1v-99.8h320V540.1z M479.9,420.1h-320v-320 h320V420.1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoilerGreenIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "boiler_green_icon.ad97b0d9b03cb885772f288ed9d00598.svg";